"use strict";

(function () {
  'use strict';

  angular.module('lr.reserve.option', []).component('lrReserveOption', {
    bindings: {
      optionData: '<',
      userChange: '&',
      currencySymbol: '@',
      transactionDays: '=',
      loading: '<'
    },
    controller: lrReserveOptionCtrl,
    templateUrl: 'components/lr.reserve.option/lr.reserve.option.base-template.html'
  });
  lrReserveOptionCtrl.$inject = ['$filter'];
  /* @ngInject */

  function lrReserveOptionCtrl($filter) {
    var vm = this;
    this.loading = false;

    this.getTemplate = function (templateType) {
      switch (templateType) {
        case 1:
          return 'components/lr.reserve.option/templates/lr.reserve.option.flat-rate.html';
          break;

        case 2:
          return 'components/lr.reserve.option/templates/lr.reserve.option.daily-rate.html';
          break;

        default:
          return 'components/lr.reserve.option/templates/lr.reserve.option.default.html';
      }
    };

    this.getNumber = function (number, spliceFirst) {
      if (number) {
        var max = parseInt(number, 10);
        var retArr = new Array(max);

        for (var i = 0; i <= max; i++) {
          retArr[i] = i;
        }

        if (spliceFirst) {
          retArr.splice(0, 1);
        }

        return retArr;
      }
    };

    this.convertToInt = function (id) {
      return parseInt(id, 10);
    };

    this.addOption = function () {
      //this.optionData.quantity = 1;
      this.userChange({
        $event: this.optionData
      }); //this.loading = true;
    };

    this.removeOption = function () {
      this.optionData.quantity = 0; //this.loading = true;

      this.userChange({
        $event: this.optionData
      });
    }; // fire when the directive data is ready


    this.$onInit = function () {// set autoset options to quantity 1 by default

      /*  Options will not us Auto Set for Update Processes
            if (this.optionData && this.optionData.autoSet === 1) {
                this.optionData.quantity = 1;
                if (!this.optionData.incurFeeDaily && this.optionData.rateType === 2) {
                    this.optionData.quantityDays = 1
                }
            }
            */
      //vm.optionData.name = 'Extra Guest Fee $10 Nightly: $10/nt/person for pre-approved guest count exceeding 8. This is for infants or small children only as the maximum occupancy of this property is 8. Please contact us for details.';
      //vm.optionData.marketingImage = 'https://encrypted-tbn2.gstatic.com/images?q=tbn:ANd9GcTq4umXfWwcbXxfA1CPZr_Vs1OMkkJec5TNaAh8m8X92ketRpSciQ';
      //vm.optionData.marketingDesc = 'Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis,';
      //if (vm.optionData && vm.optionData.priceDisplay != '') vm.priceDisplay = vm.optionData.priceDisplay;
    };

    this.$onChanges = function (changeObj) {//console.log(changeObj);
    };
  }
})();